import React from "react";
import clipIcon from "../../assets/images/retail/clip-attach.svg";
import "./styles.scss";
import i18n from "i18next";
import { DocumentType } from "../../utils/KYC";

function extractFileNameAndSize(file) {
  if (!file) {
    return { fileName: null, fileSize: 0 };
  }
  const fileName = file.fileName || file.name || i18n.t("retail.customer.KYC.fileNotUploaded");
  const fileSize = file.fileSize ? Number(file.fileSize) : (file.size ? Number(file.size) : 0);
  return { fileName, fileSize };
}

function getFileDetailsForDocType(docType, files, localVerificationFiles, localAddressFiles) {
  const isVerificationDoc = [DocumentType.INE, DocumentType.IFE, DocumentType.Passport].includes(docType);

  if (isVerificationDoc) {
    const frontFile =
      localVerificationFiles.Front ||
      files.find(file => file.type === docType && file.side === "Front");

    const backFile =
      localVerificationFiles.Back ||
      files.find(file => file.type === docType && file.side === "Back");

    const details = [];
    if (frontFile) {
      details.push({ ...extractFileNameAndSize(frontFile), side: "Front" });
    }
    if (backFile) {
      details.push({ ...extractFileNameAndSize(backFile), side: "Back" });
    }
    return details;
  }

  const lastFileOfType = [...files].find(file => file.type === docType);
  if (lastFileOfType) {
    return [{ ...extractFileNameAndSize(lastFileOfType), side: null }];
  }

  const isAddressDoc = [DocumentType["CFE/TEMLEX"], DocumentType.BankStatement].includes(docType);
  if (isAddressDoc) {
    const addressFile = localAddressFiles.Front;
    return [{ ...extractFileNameAndSize(addressFile), side: null }];
  }

  return [{ fileName: null, fileSize: 0, side: null }];
}

const InfoUploadLocalFile = ({
                               files = [],
                               docTypeToDisplay,
                               localVerificationFiles = {},
                               localAddressFiles = {},
                             }) => {
  const fileDetails = getFileDetailsForDocType(
    docTypeToDisplay,
    files,
    localVerificationFiles,
    localAddressFiles
  );

  if (!fileDetails || fileDetails.every(file => !file.fileName)) {
    return null;
  }

  return (
    <div className="wrapper_attached_files">
      {fileDetails.map(({ fileName, fileSize, side }, index) => {
        const sizeInKb = fileSize > 0 ? `${Math.ceil(fileSize / 1024)}KB` : null;
        const sideLabel = side ? ` - ${side}` : "";

        return (
          <div key={index} className='info'>
            <img src={clipIcon} alt="icon profile" />
            <span>
              {sizeInKb ? `${fileName} (${sizeInKb})${sideLabel}` : `${fileName}${sideLabel}`}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default InfoUploadLocalFile;